var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6,10c0-.552.448-1,1-1s1,.448,1,1-.448,1-1,1-1-.448-1-1Zm16-.015v9.515c0,2.485-2.015,4.5-4.5,4.5H6.5c-2.485,0-4.5-2.015-4.5-4.5V4.5C2,2.015,4.015,0,6.5,0h5.515c1.724,0,3.377.685,4.596,1.904l3.485,3.485c1.219,1.219,1.904,2.872,1.904,4.596Zm-6.096-7.375c-.551-.551-1.198-.97-1.904-1.243v5.132c0,.827.673,1.5,1.5,1.5h5.132c-.273-.706-.692-1.353-1.243-1.904l-3.485-3.485ZM3,19.5c0,.524.116,1.022.324,1.469l6.092-6.092c1.149-1.149,3.02-1.149,4.169,0l.615.615c.717.717,1.884.717,2.601,0l4.2-4.2v-1.308c0-.334-.03-.663-.088-.985h-5.412c-1.378,0-2.5-1.122-2.5-2.5V1.088c-.322-.058-.651-.088-.985-.088h-5.515c-1.93,0-3.5,1.57-3.5,3.5v15Zm18,0v-6.793l-3.493,3.493c-1.106,1.107-2.908,1.107-4.015,0l-.615-.615c-.76-.76-1.995-.76-2.755,0l-6.238,6.238c.642.722,1.576,1.177,2.616,1.177h11c1.93,0,3.5-1.57,3.5-3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/file-image.750bf91057b49fa4120e376d3c57bd72.svg";
export { ForwardRef as ReactComponent };